import React, { useState } from "react";
import { useTheme } from "../contexts/ThemeProvider";

function LoaderTable({ text }) {
    const {theme} = useTheme();

    return (
        <>
            <div className="">
                <div
                    className="position-fixed w-100 mainLoader"
                    style={{
                        height: '100%',
                        marginLeft: 0,
                        top: '0px',
                        left: '0px'
                    }}
                >
                    <div className="h-100 d-flex align-items-center justify-content-center">
                        <div className="d-flex flex-wrap align-items-center justify-content-center" style={{ flexDirection: 'column' }}>
                            {
                                theme === 'dark' ? <img width={50} className="mt-n4" src="/loader.svg" alt="img" /> : 
                                <img width={50} className="mt-n4 loader_rotate" src="/loaderlight.svg" alt="img" />
                            }
                            <p
                                className="text-center loader-text"
                            >
                                {text}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default LoaderTable;